import $ from 'jquery';
import Highcharts from 'highcharts';
import * as Nested from '../core/nested-property-helpers.js';
import {readDictionary} from './dictionary.js';

var _dsib = {
	lang: 'EN'
}

function getDisplayHandler(initializer, element, options, config, callback, dictionaryLoaded, dataOption) {
    return function() {
        var i = 0,
        	args = (Array.isArray(arguments[0])) ? Array.prototype.map.call(arguments, function(arg) {
            	return (arguments.length > 1) ? arg[0] : arg;
          	}) : arguments;

      	if (dictionaryLoaded) {
         	if (_dsib.economies.done) {
            	_dsib.economies = {};
            	readDictionary(args[i], _dsib);
         	}
         	i += 1;
      	}

      	if (dataOption) {
         	Nested.set(config, [dataOption,'csv'].join('.'), args[i]);
      	}

     	try {
         	var instance = initializer(element, options, config, _dsib);
         	element.data("dsib.dataviz.instance", instance);
      	} catch(e) {
        	console.log(e);
      	}
      	if (typeof callback === 'function') {
         	callback.call(instance);
      	}
   	}
}

function getSimpleInstance(initializer, element, options, config, callback) {
   	var instance;

   	try {
      	instance = initializer(element, options, config);
   	} catch(e) {
      	console.log(e);
   	}

   	if (typeof callback === 'function') {
      	callback.call(instance);
   	}

   	return instance;
}

function getChartSize(element, options, config, vizOption) {
    var options = $.extend({}, Nested.get(options, vizOption), Nested.get(config, vizOption)),
        widthOption = options.width, heightOption = options.height,
        containerWidth = element.width(), containerHeight = element.height(),
        width, height;
     
    width = Math.max(0, widthOption || containerWidth || 600);
    height = Math.max(0, ((/%$/).test(heightOption) 
    	? (width * parseFloat(heightOption) / 100) 
    	: parseFloat(heightOption)) 
    		|| (containerHeight > 1 ? containerHeight : 400));

    return {'width': width + 'px', 'height': height + 'px'};
};

function getErrorHandler(element, options, config, callback, vizOption, dataOption) {
    return function ( xhr ) {
		var height = element.offsetParent().height(),
		    subdiv = $('<div></div>').css({'position': 'absolute', 'top': '50%', 'left' : '50%', 'transform': 'translate(-50%, -50%)'}),
		    div = $('<div></div>').css(getChartSize(element, options, config, vizOption)).css({'position' : 'relative', 'background-color' : 'white'}).append(subdiv),
		    status = xhr.status, dataOptions = $.extend({}, Nested.get(options, dataOption), Nested.get(config, dataOption));

		if (dataOptions['error' + status]) {
		 	subdiv.html(dataOptions['error' + status]);
		} else {
		 	subdiv.text(xhr.statusText);
		}

		var instance = {container: subdiv, destroy: function() {}, userOptions: true};
		element.data("dsib.dataviz.instance", instance);
		element.append(div);

		if (typeof callback === 'function') {
		 	callback.call(instance);
		} 
    }
}

function dataviz(initializer, options, vizOption, dataOption) {
    var dataUrlOption = [dataOption,'url'].join('.'),
        dataUrlCompatOption = [dataOption,'csvURL'].join('.'),
        dictionaryUrlOption = [vizOption,'dictionary'].join('.');

    return function(config, callback) {
        if (typeof config !== 'object') {
            config = JSON.parse(config);
        }

        var csvURL = Nested.get(config, dataUrlOption) || Nested.get(config, dataUrlCompatOption),
            dictURL = Nested.get(options, dictionaryUrlOption);

        if (Nested.hasOwn(config, dictionaryUrlOption) && !Nested.get(config, dictionaryUrlOption)) {
            // Don't load dictionnary when dataviz explicitly declare not using it
            dictURL = false;
        }

        // Skip ajax for simple charts
        if (csvURL || dictURL) {
            var element = this, promises = [];

            if (dictURL) {
                // Load dictionnary
                if (!_dsib.economies) {
                    _dsib.economies = $.ajax({
                        url: dictURL,
                        dataType: 'text'}
                    );
                }
                if (_dsib.economies.done) {
                    promises.push(_dsib.economies);
                } else {
                	dictURL = false;
                }
            }

            if (csvURL) {
                // Load CSV
                delete Nested.get(config, dataOption)['url'];
                delete Nested.get(config, dataOption)['csvURL'];
                promises.push($.ajax({
                        url: csvURL,
                        dataType: 'text'}
                    )
                );
            }

            return $.when.apply(this, promises)
                // Init chart upon success
                .done(getDisplayHandler(initializer, element, options, config, callback, !!dictURL, (csvURL) ? dataOption : null))
                // Display error upon failure
                .fail(getErrorHandler(element, options, config, callback, vizOption, dataOption));
        } else {
            return getSimpleInstance(initializer, this, options, config, callback);
        }
    };
}

export default function createJQueryExtension(viztype, initializer, vizOption, dataOption) {
	return function (options) {
	   var args = arguments;

	   	if (Highcharts) { 
		   	if (!Highcharts._dsib) {
	    		Highcharts._dsib = _dsib;
		   	} else {
		   		_dsib = Highcharts._dsib;
			}
		}

		if (options && options.language) {
        	_dsib.lang = options.language;
         	delete options.language;
      	}

	    return this.map(function () {
	      	var elt = $(this),
	            instance = elt.data("dsib.dataviz.instance");
	      	if (instance) {
	         	if (!instance.done && typeof options == "string") {
	             	if (options === "reconfigure") {
	               		var container = $(instance.container).parent();
	               		instance.destroy();
               			container.remove();
	               		instance = dataviz(initializer, elt.data("dsib.dataviz.options"), vizOption, dataOption).call(elt, args[1], args[2]);
	               		elt.data("dsib.dataviz.instance", instance);
	            	} else {
	               		instance[options].apply(instance, $.makeArray(args).slice(1));
	            	}
	         	}
	      	} else if (options === undefined || typeof options == "object") {
	           	instance = dataviz(initializer, options, vizOption, dataOption).call(elt, elt.data(viztype), args[1]);
	           	elt.data("dsib.dataviz.instance", instance);
	           	elt.data("dsib.dataviz.options", options);
	      	}
	      	return instance;
	   	});
	}
}